export class AwsEbsVolumeRestoreData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerVolumeId",
            "baseName": "providerVolumeId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEbsVolumeRestoreData.attributeTypeMap;
    }
    constructor() {
    }
}
